module.exports = __webpack_public_path__ + "assets/img/企业简介_02.304bb8c4.jpg";